import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { Chart } from '@mc-prime/einstein-ui-components';

const config = {
  inner: 72,
  autoFitMode: 'fit',
  color: {
    column: ['type'],
    colors: ['#935dea', '#4d97e6']
  },
  dimension: {
    column: ['type']
  },
  legend: {
    position: 'right-middle',
    showBorder: false,
    showHeader: false
  },
  showMeasureTitle: false,
  selectMode: 'single',
  valueType: 'number',
  plots: [
    {
      column: ['count']
    }
  ],
  theme: {
    base: 'wave'
  }
};

class ClassDetailsChart extends Component {
  render() {
    const { formatMessage } = this.props.intl;
    const rows = [
      {
        type: formatMessage({
          id: 'components.ecs.analytics.classDetails.classPerformance.einstein'
        }),
        count: this.props.einsteinCount
      },
      {
        type: formatMessage({
          id: 'components.ecs.analytics.classDetails.classPerformance.fallback'
        }),
        count: this.props.fallbackCount
      }
    ];

    config.title = {
      label: formatMessage(
        {
          id:
            'components.ecs.analytics.classDetails.classPerformance.chartTitle'
        },
        { type: this.props.assetType }
      ),
      align: 'center'
    };
    const rowsMetadata = [
      {
        column: 'type',
        type: 'dimension',
        label: formatMessage({
          id: 'components.ecs.analytics.classDetails.classPerformance.type'
        })
      },
      {
        column: 'count',
        type: 'measure',
        label: formatMessage({
          id: 'components.ecs.analytics.classDetails.classPerformance.count'
        })
      }
    ];

    return (
      <div className="class-details-chart-container">
        <Chart
          className="wave-chart-component"
          chartModule="sfdc-pie-chart"
          modulePrefix="../"
          config={config}
          rows={rows}
          rowsMetadata={rowsMetadata}
        />
      </div>
    );
  }
}

ClassDetailsChart.propTypes = {
  actions: PropTypes.object,
  assetType: PropTypes.string,
  fallbackCount: PropTypes.number,
  einsteinCount: PropTypes.number,
  location: PropTypes.object
};

export default injectIntl(ClassDetailsChart);
